import { render, staticRenderFns } from "./KidsfoundationLogoWhite.vue?vue&type=template&id=3c248ee5&"
import script from "./KidsfoundationLogoWhite.vue?vue&type=script&lang=js&"
export * from "./KidsfoundationLogoWhite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports